import DateTimeService from '@app/Services/DateTimeService';

export type OpenRange = {
    dateFrom: Date;
    dateTo?: Date;
};

export type Range = {
    dateFrom: Date;
    dateTo: Date;
};

export class RangeHelper {
    public static isInOpenRange<T extends OpenRange> (range: T, date: Date): boolean {
        return range.dateFrom <= date && (!range.dateTo || date <= range.dateTo);
    }

    public static findSelectedFunctionRange<T extends OpenRange> (ranges: T[], date: Date): T | null {
        let prev: T | null = null;
        let within: T | null = null;
        let next: T | null = null;
        const prevNotBefore = DateTimeService.addYears(date, -1);
        for (let i = 0; i < ranges.length; i++) {
            const cur = ranges[i];
            if (cur.dateTo && cur.dateTo < date && cur.dateTo >= prevNotBefore) {
                prev = cur;
                continue;
            }
            if (RangeHelper.isInOpenRange(cur, date)) {
                within = cur;
                continue;
            }
            if (cur.dateFrom > date) {
                next = cur;
                break;
            }
        }
        return within || next || prev;
    }
}
